export default "__VITE_ASSET__BTEikWvD__"